<template>
  <div class="g-flex g-row-center">
    <div class="total-width white-bg g-m-t-40">
      <div class="title g-rela g-flex g-row-center g-weight-font g-font-24">
        理论考试
      </div>
      <div class="g-flex g-row-center g-m-t-35">
        <div>
          <p class="g-font-20 g-weight-font g-text-center">{{ examData.paperName }}</p>
          <div class="g-m-t-26 blue-box">
            <!--  已提交 合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="examData.isPassed">
              <p class="g-font-30 green-text">{{ examData.score }}分</p>
              <img src="@/assets/examination/passed-icon.png" class="res-icon" alt="">
            </div>
            <!--  已提交 不合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="!examData.isPassed">
              <p class="g-font-30 red-text">{{ examData.score }}分</p>
              <img src="@/assets/examination/failed-icon.png" class="res-icon" alt="">
            </div>
            <!--  时间 | 题数 | 分数   -->
            <div class="g-flex g-row-center g-m-t-20">
              <div class="g-text-center">
                <p class="remark-text g-font-12">考试时间</p>
                <p class="g-m-t-10 green-text g-weight-font">{{ examData.duration }}分钟</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">题数</p>
                <p class="g-m-t-10 green-text g-weight-font">{{ examData.questionNum }}题</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">满分</p>
                <p class="g-m-t-10 green-text g-weight-font">{{ examData.totalScore }}分</p>
              </div>
            </div>
            <!--   合格提醒   -->
            <div class="g-m-t-26 warning-box g-font-12" v-if="examData.isPassed">
              恭喜你通过{{ examData.paperName }}的理论考试，您现在可以进行线上实操考试。
            </div>
            <!--   不合格提醒   -->
            <div class="g-m-t-26 warning-box g-font-12" v-else>
              很遗憾！您的考试分数不合格，未获得{{ examData.paperName }}证书！
            </div>
          </div>
          <!--   合格按钮组   -->
          <div class="g-m-t-30 g-flex g-row-center" v-if="examData.isPassed">
            <div class="btn btn1" @click="toTestDetail">
              查看答卷
            </div>
            <div class="btn btn2 g-m-l-30" @click="toCert">
              查看证书
            </div>
          </div>
          <!--   不合格按钮组   -->
          <div class="g-m-t-30 g-flex g-row-center" v-else>
            <div class="btn btn1" @click="toTestDetail">
              查看答卷
            </div>
            <div class="btn btn2 g-m-l-30" @click="againExam">
              再次考试
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "written-test-result",
  data(){
    return{
      examData:{
        duration:120,
        questionNum:50,
        totalScore:100,
        score:0,
        isPassed:false,
        paperId: null,
      }
    }
  },
  created() {
    this.examData=this.$route.params
  },
  methods:{
    againExam(){
      this.$router.push({
        name:'written-test',
        query: {
          paperId:this.examData.paperId,
        }
      })
    },
    toTestDetail(){
      this.$router.push({
        name:"written-test-detail",
        query: {
          paperId:this.examData.paperId,
        }
      })
    },
    toCert(){
      this.$router.push({
        name:"mine",
        query: {
          menuIndex:6,
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.white-bg{
  background: #fff;
  padding-bottom: 80px;
}

.title{
  background-image: url("../../assets/course-list/course-title-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 306px;
  height: 91px;
  color: #fff;
  margin: -20px auto 0 auto;
}

.blue-box{
  margin: 0 auto;
  padding: 30px 255px;
  background: #e9f2ff;
  border: 1px dashed #407aff;
  border-radius: 5px;
}

.success-icon{
  width: 44px;
  height: 44px;
}

.btn{
  padding: 8px 22px;
  border-radius: 5px;
  cursor: pointer;
}

.btn1{
  background: #f6f6f8;
  color: #407aff;

  &:hover{
    background: #407aff;
    color: #fff;
  }
}

.btn2{
  background: #407aff;
  color: #fff;

  &:hover{
    background: rgba($color:#407aff, $alpha: 0.8);
    color: #fff;
  }
}


.res-icon{
  width: 70px;
  height: 70px;
  position: absolute;
  right: -225px;
  top: 0;
}

.warning-box {
  background: #fff4ef;
  border-radius: 5px;
  color: #FF5918;
  padding: 10px 17px;
  width: 350px;
}
</style>